const formatGermanPhoneNumberForTel = (phone: string): string => {
  // Nur Ziffern extrahieren
  const digits = phone.replace(/[^\d]/g, '');

  // Wenn die Nummer mit 0 beginnt, ersetze sie durch +49
  let international = digits;
  if (digits.startsWith('0')) {
    international = '+49' + digits.substring(1);
  } else if (!digits.startsWith('+')) {
    // Falls es weder 0 noch + hat, optional +49 hinzufügen oder belassen
    international = '+49' + digits;
  }

  return `tel:${international}`;
};

export { formatGermanPhoneNumberForTel };
